import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import ge from './locales/ge.json';
import ru from './locales/ru.json';
import am from './locales/am.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ge: { translation: ge },
      en: { translation: en },
      ru: { translation: ru },
      am: { translation: am }
    },
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

export default i18n;
